var map = {
	"./Netcat.png": 9147,
	"./QuickLabs.png": 1903,
	"./bank.png": 4378,
	"./blood-bank.png": 9479,
	"./budget.png": 5559,
	"./bus.png": 6180,
	"./c++.png": 1087,
	"./c.png": 9097,
	"./car-service.png": 9498,
	"./cn.png": 2051,
	"./collage.png": 5301,
	"./css.png": 2687,
	"./dart.png": 3959,
	"./desktop.png": 2438,
	"./document.png": 8563,
	"./express.png": 6914,
	"./eye.png": 6734,
	"./flutter.png": 964,
	"./github.png": 9449,
	"./gym.png": 9551,
	"./heart.png": 150,
	"./hospital.png": 4153,
	"./hostel.png": 2749,
	"./hotel.png": 664,
	"./html.png": 5887,
	"./insta.png": 5383,
	"./java.png": 8768,
	"./js.png": 3345,
	"./linkedin.png": 2098,
	"./loan.png": 3614,
	"./logo.png": 3153,
	"./ml.png": 9595,
	"./mongoDB.png": 5132,
	"./movies.png": 2467,
	"./npm.png": 433,
	"./os.png": 8010,
	"./python.png": 6602,
	"./react.png": 6843,
	"./ruby.png": 9176,
	"./sql.png": 8306,
	"./taxi.png": 4084,
	"./ts.png": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;